<div class="modal-container">
  <h1 mat-dialog-title class="filter-modal-header">Filters <button class="close-btn-wrapper"
      (click)="closeDialogFilter()" mat-icon-button><mat-icon class="close-btn">close</mat-icon></button></h1>

  <!-- Code for 3 kinds of filters displayed on the left of mobile filters component -->
  <div mat-dialog-content class="filterWrap">
    <div class="filter-names-container">
      <div class="filter-name" [ngClass]="{'active-filter': selectedFilter === 'category'}"
        (click)="changeFilter('category');">CATEGORY</div>
      <div class="filter-name" [ngClass]="{'active-filter': selectedFilter === 'type'}" (click)="changeFilter('type');">
        TYPE</div>
      <div class="filter-name" [ngClass]="{'active-filter': selectedFilter === 'location'}"
        (click)="changeFilter('location');">LOCATION</div>
    </div>

    <!-- Code to display options according to the selected filter -->
    <div class="filter-values-container">
      <div class="filter-states" [ngClass]="{'category-state': selectedFilter === 'category'}">
        <app-custom-filter [attribute]="'category'" [filterData]="filterData"
          [origin]="'mobileFilters'"></app-custom-filter>
      </div>
      <div class="filter-states" [ngClass]="{'category-state': selectedFilter === 'type'}">
        <app-custom-filter [attribute]="'tags'" [filterData]="filterData"
          [origin]="'mobileFilters'"></app-custom-filter>
      </div>
      <div class="filter-states" [ngClass]="{'category-state': selectedFilter === 'location'}">
        <app-custom-filter [attribute]="'address'" [filterData]="filterData"
          [origin]="'mobileFilters'"></app-custom-filter>
      </div>
    </div>
  </div>

  <!-- Code for reset and apply buttons for the filters selected -->
  <div mat-dialog-actions class="action-buttons">
    <div class="col-4 col-md-4 clear-refinement">
      <a mat-button class="filter-btn"><ais-clear-refinements class="reset" [resetLabel]="'Reset'"
          (click)="resetFilters()"></ais-clear-refinements></a>
    </div>
  </div>

</div>